<div role="contentinfo" class="footer bg-primary text-white text-center">
  <div class="footer-quicklinks bg-black w-100"></div>
  <div class="footer-text d-flex align-items-center justify-content-center w-100">
    <div class="footer-content mt-lg-3 mt-2 d-flex flex-column align-items-center">
      <div class="m-290">
        <img alt="" class="footer-logo mb-3" src="assets/images/logos/LogoWhite.png" draggable="false" />
      </div>
      <ul class="footer-links">
        <li class="footer-link">
          <a href="{{ 'footer.privacy.link.url' | translate }}">
            <div class="privacy-link text-white font-size-14">{{ 'footer.privacy.link' | translate }}</div>
          </a>
        </li>
        <li class="d-lg-block d-none">
          <div class="divider"></div>
        </li>
        <li class="footer-link">
          <a href="{{ 'footer.your.privacy.link.url' | translate }}">
            <div class="privacy-link text-white font-size-14">
              {{ 'footer.your.privacy.link' | translate }}
            </div>
          </a>
        </li>
        <li class="d-lg-block d-none">
          <div class="divider"></div>
        </li>
        <li class="footer-link">
          <!-- OneTrust Cookies Settings button start -->
          <a class="privacy-link text-white font-size-14 ot-sdk-show-settings">Cookie Settings</a>
          <!-- OneTrust Cookies Settings button end -->
        </li>
      </ul>
      <div class="m-290">
        <p
          class="text-white font-size-14 text-center footer-text-rights"
          [innerHTML]="'nav.club.rights' | translate | markdownTranslate"
        ></p>
      </div>
    </div>
  </div>
</div>
